;(function( $, undefined ) {
	function stop_prop( e ) {
		if ( e && e.preventDefault ) { e.preventDefault(); }
		if ( e && e.stopPropagation ) { e.stopPropagation(); }

		return false;
	}

	function reveal_add( e ) {
		var	modalId          = 'shipper-add-user',
			focusAfterClosed = this,
			focusWhenOpen    = undefined,
			hasOverlayMask   = false;

		SUI.openModal( modalId, focusAfterClosed, focusWhenOpen, hasOverlayMask );

		return stop_prop( e );
	}

	function hide_add( e ) {
		var $me = $( '#shipper-add-user' ),
			$ins = $me.find( ':input' );

		$ins.val( '' );
		SUI.closeModal()

		return stop_prop( e );
	}

	function handle_verify_user( e ) {
		var $me = $( '#shipper-add-user' ),
			$input = $me.find( '#shipper-permissions-add' ),
			$nonce = $me.find( 'button.shipper-add' );

		$.post( ajaxurl, {
			action: 'shipper_permissions_verify',
			user_id: $input.val(),
			_wpnonce: $nonce.attr( 'data-add' )
		} ).done( function( rsp ) {
			var status   = !! (rsp || {}).success,
				rsp_data = (rsp || {}).data || ''
				data     = rsp_data.data || rsp_data; // sometimes data can be nested
				message  = rsp_data.message || rsp_data; // sometimes message can be nested
			;

			hide_add();

			if ( ! status ) {
				show_error( message );
				return false;
			}

			if ( message ) {
				add_user_row( data, message );
				$input.val( null ).trigger( 'change' );
			}
		} );

		return stop_prop( e );
	}

	function remove_user( e ) {
		$( e.target ).closest( '.shipper-user-item' ).remove();
		return stop_prop( e );
	}

	function enter_to_verify_user ( e ) {
		var key = e.which;
		if ( 13 === key ) {
			handle_verify_user( e );
		}
	}

	function show_error( message ) {
		show_notice( message, 'error' );
	}

	function show_notice( message, type ) {
		message = '<p>' + message + '</p>';
		var options = {
			type: type
		}

		SUI.openNotice( 'shipper-add-user-notice', message, options );
	}

	function show_success( message ) {
		show_notice( message, 'success' );
	}

	function add_user_row( row_html, message ) {
		var $me = $( '.shipper-page-settings-permissions .shipper-users-list' )
			$row = $( row_html ),
			user_id = $row.find( ':hidden' ).val(),
			username = $row.find( '.shipper-user' ).text();
		if ( ! user_id ) {
			return false;
		}
		if ( $me.find( ':hidden[value="' + user_id + '"]' ).length ) {
			return false;
		}
		$me.append( row_html );
		show_success( message );
	}

	function init() {
		if ( ! $( '.shipper-page-settings-permissions' ).length ) {
			return false;
		}


		var $add = $( '#shipper-permissions-add' ),
			wpnonce = $add.attr( 'data-wpnonce' );

		$add.SUIselect2({
			allowClear: false,
			dropdownCssClass: 'sui-select-dropdown',
			dropdownParent: $('#shipper-add-user'),
			ajax: {
				url: window.ajaxurl,
				type: "POST",
				data: function (params) {
					return {
						action: 'wdp-usersearch',
						hash: wpnonce,
						q: params.term,
					};
				},
				processResults: function (data) {
					return {
						results: data.data
					};
				},
			},
			templateResult: function (result) {
				if (typeof result.id !== 'undefined' && typeof result.label !== 'undefined') {
					return $(result.label);
				}
				return result.text;
			},
			templateSelection: function (result) {
				return result.display || result.text;
			},
		});

		$( document ).on( 'click', 'button.shipper-reveal-add', reveal_add );
		$( document ).on( 'click', '#shipper-add-user .shipper-cancel', hide_add );
		$( document ).on( 'click', '#shipper-add-user button.shipper-add', handle_verify_user );
		$( document ).on( 'keydown', '#shipper-add-user input', enter_to_verify_user );
		$( document ).on( 'click', '.shipper-user-item a.shipper-rmv', remove_user );
	}

	$( init );
} )( jQuery );
